"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var time_1 = require("../utils/time");

var withTheme_1 = require("../utils/withTheme");

exports.TimeIndicator = function (_a, _b) {
  var theme = _b.theme;

  var duration = _a.duration,
      position = _a.position,
      uiPosition = _a.uiPosition,
      others = __rest(_a, ["duration", "position", "uiPosition"]);

  return withTheme_1.withTheme(theme, 'time-indicator')(React.createElement("div", __assign({}, others), time_1.toReadableTime(uiPosition !== null && typeof uiPosition === 'number' ? uiPosition : position), position <= duration ? " / " + time_1.toReadableTime(duration) : null));
};

exports.TimeIndicator.contextTypes = {
  theme: PropTypes.object
};
exports["default"] = exports.TimeIndicator;